__turbopack_context__.v({
  "canvas": "sparkles-module__ckK3Ia__canvas",
  "root": "sparkles-module__ckK3Ia__root",
});
